import qs from "qs";
import http from "../../h5-network/request.js";
let query = qs.parse(location.search.slice(1));

const source = 'WX';
export default {
    param() {
        //ma_code 会员中心过来的
        if (query.ma_code) {

            let member = sessionStorage.getItem(`INVERTADVISER_WX_MEMBER_${query.ma_code}`);
            member && (member = JSON.parse(member))

            return {
                source,
                memberId: query.ma_id || member?.memberId,
                sign: query.ma_sign || member?.sign,
                ...query
            }
        }

        //wxh5
        //微信授权带参 ?tmrId=cawenx&openid=ovvc_txQDRYVFJvH8eGYYU_J30Hk&unionid=oSWTislvDZJDc0MPunpNj9bTCY6A&nickname=%F0%9F%8D%A5

        let member = sessionStorage.getItem(`INVERTADVISER_WX_MEMBER_${query.unionid}`);
        member && (member = JSON.parse(member))
        return {
            source,
            token: member?.token || '',
            memberId: member?.memberId || '',
            sign: member?.sign || '',
            tmrId: '',// 企业微信带来的tmrId 员工号
            openid: '',
            unionid: '',
            nickname: '',
            ...query
        }
    },
    linkSearch(param) {
        const { memberId, sign } = this.param();
        return `${qs.stringify({ source, ma_id: memberId, ma_sign: sign, ...param, type: 2, ...this.param() })}`
    },
    async isLogin() {
        const { ma_code, memberId, sign, unionid } = this.param();

        if (ma_code) {

            if (!memberId && !sign) {
                return Promise.reject(false)
            }

            return Promise.resolve(true)

        } else {
            //微信授权流程 -wechatUser 判断是否绑定微信 绑定:返回登录态
            const build = await http({
                loading: true,
                url: '/bdzb-permission/usr/wechatUser',
                data: {},
                method: 'POST',
                dialog: true
            }).then(data => {
                if (data) {
                    window.sessionStorage.setItem(
                        `INVERTADVISER_WX_MEMBER_${unionid}`,
                        JSON.stringify(data)
                    );
                    //member_third_token 兼容老北斗金牛
                    window.localStorage.setItem("member_third_token", JSON.stringify(data));
                }
                return data
            }, () => false)

            if (build) {
                return Promise.resolve(true)
            }
            return Promise.reject(false)
        }
    },
    goToLogin() {
        const { ma_code, unionid } = this.param();
        //ma_code 会员中心 带在url 上的登录信息
        if (ma_code) {
            location.hash = `#/member-login?saveKey=${ma_code}&from=${location.hash.replace('#/', '')}`
        } else {
            location.hash = `#/wx-login?saveKey=${unionid}&from=${location.hash.replace('#/', '')}`
        }
    }
}